import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { latLng, tileLayer } from "leaflet";
import { DataService } from "src/app/shared/Services/data.service";
import * as echarts from "echarts";
import { Subject } from "rxjs";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { GetCurrentShift } from "src/app/shared/Services/getCurrentShift";
import { takeUntil } from "rxjs/operators";


@Component({
  selector: "app-operator-dashboard",
  templateUrl: "./operator-dashboard.component.html",
  styleUrls: ["./operator-dashboard.component.scss"],
})
export class OperatorDashboardComponent implements OnInit {
  @ViewChild("interlock") interlock!: TemplateRef<any>;
  ganttBool: boolean = true;
  private destroy$: Subject<void> = new Subject<void>();
  private cancelPreviousRequests$ = new Subject<void>();
  shift_Time: any;
  isCollapsed = true;
  isDisabled: boolean = true;
  role: any;
  device_bar_chart: any;
  custId: any;
  machine_List: any = [];
  showGantt: boolean = false;
  selectedCars = "All Shift";
  chatSubmit: boolean;
  formData: FormGroup;
  deviceName: any;
  apiInterval: any;
  currentShift: any;
  params: any;
  intervalFlag: boolean = true;
  deviceType: any;
  avail: any;
  prodLoss: any;
  energycost: any;
  showHourchart: boolean = false;
  hourlyData: any;
  userData: any;
  current: any;
  LUT: any;
  status: any;
  m_effic: any;
  parts: any;
  combinedData: any;
  availability: any;
  quality: any;
  perf: any;
  pieStatus: any;
  r_power: any;
  a_power: any;
  energy: any;
  t_energy: any;
  finalcombinedData: any = [];
  selectedDateOption: string = "Live";
  historycombinedData: any = [];
  selectedMachine: any;
  count: any;
  previousDays: any = [];
  type: any;
  showChart: boolean = false;
  pie_response: any;
  clustr_Chart: boolean = false;
  cluster_data: any;
  showCombined: boolean = false;
  historydata: boolean = false;
  historyDatas: any = [];
  selecteMachineId: String = "";
  selectReason: any;
  typeData: any = [];
  selectedRejection: String = "";
  action: any;
  sampleName: String = "";
  startDate: any;
  maxDate: any;
  minDate: any;
  shiftsArr: any = [];
  machineData: any = [];
  partData: any = [];
  rejectionData: any = [];
  tempData: any = [];
  selectedPart: any;
  selectedPartproduced: any = 0;
  selectedPartrejected: any = 0;
  reasonData: any = [];
  selectedShifts: any;
  pageSize: any;
  currentPage: any = 1;
  itemsPerPage: any = 3;
  pageSize1: any;
  currentPage1: any = 1;
  itemsPerPage1: any = 5;
  pageSize2: any;
  currentPage2: any = 1;
  itemsPerPage2: any = 3;
  searchTerm2: any = "";
  searchTerm: any = "";
  validcount: any;
  showModel: boolean = false;
  filteredData: any = [];
  filteredsampleData: any = [];
  searchRecord: any = "";
  isbtn: boolean = false;
  currentTime: any;
  downtimeType: string[] = [];
  selectedType: string = "Idle/Off";
  showfields: boolean = false;
  private deactivate: boolean = true;
  addRecord: boolean = true;
  timerRunning = false;
  startTime: any = "";
  timer: any;
  endTime: any = "";
  duration: any;
  validationform: FormGroup;
  submitted: boolean = false;
  deviceList: any;
  errmsg: String = "";
  sampleData: any = [];
  hideMachine: boolean = false;
  shiftId: any;
  selectDuration: number = 5;
  shiftName: any;
  singlebool: boolean = true;
  searchCount: any;
  validNumber: any;
  addBool = false;
  timeBool = false;
  rejectionReasons: any = [];
  downtimeReasons: any = [];
  downtimeReasons2: any = [];
  downtimevalues: any = [];
  endtimeData: any = [];
  subReasonData: any = [];
  downtimeData: any;
  selectedTimezone: any;
  checkBool: boolean = true;
  ganttData: any;
  downData: any = [];
  finalData: any = [];
  orderedData: any = [];
  showData: boolean = false;
  currEnd: any;
  diffData: any;
  currentPart: any;
  result: any;
  selectshift: any;
  departmentData: any = [];
  actions = ''
  commentId: any
  currentShiftData: any;
  isSame: boolean = false;
  isToday: boolean = true;
  showPartData = true;
  isMiltiselection = false;
  private subscriptions: Subscription[] = [];
  packetEndtime: any;
  currentStatus: any;
  lastPacketEndtime: boolean = false;
  hours: any = []
  selectedHour: string = '';
  commentsPerPage: any = 5;
  commentcurrentPage: any = 1;
  constentSize: any;
  operatorName: string = '';
  commentText: string = "";
  comments = [];
  configType: any;
  pierunning_response: any;
  pieidle_response: any;
  livepart: any = ''
selectedStatus: string = 'all';
interlockData: any = [];
custName:any=''
  constructor(
    public formBuilder: FormBuilder,
    private dataservice: DataService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private getCurrent: GetCurrentShift
  ) { }

  ngOnInit() {
    this.userData = JSON.parse(sessionStorage.getItem("currentUser"));
    this.custId = this.userData["user"]["custId"];
    this.custName = this.userData["user"];
    this.operatorName = this.userData["user"]["name"];
    this.getDepartment(this.custId);
    this.role = this.userData["user"]["role"];
    this.shift_Time = this.userData["user"]["currentShift"];
    this.shiftId = this.shift_Time["shiftId"];
    this.shiftName = this.shift_Time["shiftName"];
    this.selectedShifts = this.shift_Time["usershiftId"];
    this.selectedTimezone = this.userData["user"]["timeZone"];
    this.maxDate = moment(this.shift_Time["currentDate"]).format("YYYY-MM-DD");
    this.minDate = moment(this.shift_Time["currentDate"])
      .subtract(2, "day")
      .format("YYYY-MM-DD");
    this.startDate = this.maxDate;
   
    if (this.isMiltiselection) {
      this.updateTime();
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.updateTime();
      }, 1000);
    }
    this.auditLogs()
  }

  auditLogs() {
    let obj = {
      custID: this.custId
    }
    const subscription = this.dataservice
      .reportApi(
        "auditlog/operator",
        obj
      ).subscribe(
        (res) => {

        },
        (error) => {
          this.toastr.error("Server Unreachable", error);
        }
      );
    this.subscriptions.push(subscription);
  }

  initialData() {
    this.getData();
    // this.getshiftDetails();
    this.getReasonData();
    this.initalizeform();
  }

  refreshData() {
    this.cancelPreviousRequests$.next();
    this.getReasonData();
    this.initalizeform();
    if (this.configType != "no_part") {
      if (this.isMiltiselection) {
        this.getRecords();
      }
      // else{
      //   this.getlivepart()
      // }
      this.getPartData();
      this.getPartCount(this.params);
    }
    this.getDowntimeData();
    this.getCustData(this.params);
    const isCurrentShift = this.currentShiftData["usershiftId"] === this.selectedShifts && moment(this.currentShiftData["currentDate"]).format("YYYY-MM-DD") === this.startDate;
    if (isCurrentShift) {
      this.getInterlockData(this.params);
    }
  }

  // getshiftDetails() {
  //   const subscription = this.dataservice
  //     .get(`api/shift?custId=${this.custId}`)
  //     .subscribe((res) => {
  //       if (res) {
  //         this.shiftsArr = res;
  //         this.selectshift = this.shiftsArr.filter((val) => {
  //           if (val.usershiftId == this.selectedShifts) {
  //             return val;
  //           }
  //         });
  //         this.currentShiftData = this.getCurrent.getCurrentShift(
  //           this.shiftsArr,
  //           this.selectedTimezone
  //         );
  //         this.getData();
  //       }
  //     });
  //   this.subscriptions.push(subscription);
  // }

  getshiftDetails(departmentname: any) {
    const data = this.departmentData.find(
      (val) => val.departmentName === departmentname
    );

    if (data) {
      this.shiftsArr = data.shiftData;
      this.currentShiftData = this.getCurrent.getCurrentShift(
        this.shiftsArr,
        this.selectedTimezone
      );
      this.userData.user.currentShift = this.currentShiftData;
      sessionStorage.setItem("currentUser", JSON.stringify(this.userData));

      this.userData = JSON.parse(sessionStorage.getItem("currentUser"));
      this.custId = this.userData["user"]["custId"];
      this.role = this.userData["user"]["role"];
      this.shift_Time = this.userData["user"]["currentShift"];
      this.shiftId = this.shift_Time["shiftId"];
      this.shiftName = this.shift_Time["shiftName"];
      this.selectedShifts = this.shift_Time["usershiftId"];
      this.selectedTimezone = this.userData["user"]["timeZone"];
      if (this.startDate == moment(this.shift_Time["currentDate"]).format("YYYY-MM-DD")) {

        this.maxDate = moment(this.shift_Time["currentDate"]).format(
          "YYYY-MM-DD"
        );
        this.minDate = moment(this.shift_Time["currentDate"])
          .subtract(2, "day")
          .format("YYYY-MM-DD");
        this.startDate = this.maxDate;
      }

      this.selectshift = this.shiftsArr.filter(
        (val) => val.usershiftId === this.currentShiftData.usershiftId
      );

      this.hours = this.generateHourArray(this.selectshift[0]);
    }
  }

  generateHourArray(shift: any) {
    let startHour = parseInt(shift.startTime.split(':')[0], 10);
    let endHour = parseInt(shift.endTime.split(':')[0], 10);
    const hours = [];

    // If shift ends next day, we add 24 to endHour
    if (shift.endNextDayFlag && endHour < startHour) {
      endHour += 24;
    }

    for (let h = startHour; h <= endHour; h++) {
      const displayHour = (h % 24).toString().padStart(2, '0') + ':00';
      hours.push({ hour: displayHour });
    }

    return hours;
  }

  getDepartment(custId) {
    this.dataservice
      .get(`department?custId=${custId}`)
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe((res: any) => {
        if (res) {
          this.departmentData = res["data"];
           this.initialData();
        }
      });
  }
partcountType:string=''
  getData() {
    let urlData:any;
    if(this.role=='OPERATOR'){
      urlData= `api/device?custId=${this.userData["user"]["custId"]}&operatorId=${this.userData["user"]["name"]}&shiftName=${this.shiftName}&date=${this.startDate}`
    }else{
      urlData= `api/device?custId=${this.userData["user"]["custId"]}&supervisorId=${this.userData["user"]["email"]}&shiftName=${this.shiftName}&date=${this.startDate}`
    }
    const subscription = this.dataservice
      .get(
        `${urlData}`
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe((res) => {
        this.machine_List = res;
        if (this.machine_List.length != 0) {
          this.showData = true;
          this.showPartData = true;
          this.selectedMachine = this.machine_List[0]["deviceName"];
          this.selecteMachineId = this.machine_List[0]["deviceId"];
          this.partcountType = this.machine_List[0]["partcountType"];
          if (this.machine_List[0]["meterSupplier"] != 'K2-V1.1') {
            this.downtimeType = ["Idle/Off", "Idle", "Off", "Running"];
          } else {
            this.downtimeType = ["Idle/Off", "Idle", "Off", "Running", "Breakdown", "Interlock"];
          }
          this.getshiftDetails(this.machine_List[0]["departmentName"]);
          this.configType = this.machine_List[0]["oee"];
          this.getDowntimeData();
          if (this.configType != "no_part" && this.isMiltiselection) {
            this.getRecords();
          }
          // else if (this.configType != "no_part" && !this.isMiltiselection) {
          //   this.getlivepart();
          // }
          this.result = this.gettimestamp(this.selectshift);
          var shared_data = {
            custID: this.custId,
            deviceID: this.machine_List[0]["deviceId"],
            deviceName: this.machine_List[0]["deviceName"],
            deviceType: this.machine_List[0]["deviceType"],
            startTime: this.result["starttime"],
            endTime: this.result["endtime"],
          };
          if (Object.values(shared_data).length != 0) {
            this.params = shared_data;
            this.getMainData();
          }
        } 
        else {
          this.showPartData = false;
          const subscription = this.dataservice
            .get("api/device")
            .pipe(takeUntil(this.cancelPreviousRequests$))
            .subscribe((res:any) => {
              this.machine_List = res.filter((val:any)=> val["meterSupplier"] == 'K2-V1.1');
              if (this.machine_List.length != 0) {
                this.showData = true;
                this.selectedMachine = this.machine_List[0]["deviceName"];
                this.selecteMachineId = this.machine_List[0]["deviceId"];
                this.getshiftDetails(this.machine_List[0]["departmentName"]);
                if (this.machine_List[0]["meterSupplier"] != 'K2-V1.1') {
                  this.downtimeType = ["Idle/Off", "Idle", "Off", "Running"];
                } else {
                  this.downtimeType = ["Idle/Off", "Idle", "Off", "Running", "Breakdown", "Interlock"];
                }
                this.configType = this.machine_List[0]["oee"];
                this.getDowntimeData();
                if (this.configType != "no_part" && this.isMiltiselection) {
                  this.getRecords();
                }
                // else if (this.configType != "no_part" && !this.isMiltiselection) {
                //   this.getlivepart();
                // }
                this.result = this.gettimestamp(this.selectshift);
                var shared_data = {
                  custID: this.custId,
                  deviceID: this.machine_List[0]["deviceId"],
                  deviceName: this.machine_List[0]["deviceName"],
                  deviceType: this.machine_List[0]["deviceType"],
                  startTime: this.result["starttime"],
                  endTime: this.result["endtime"],
                };
                if (Object.values(shared_data).length != 0) {
                  this.params = shared_data;
                  this.getMainData();
                }
              } else {
                this.showData = false;
              }
            });
          this.subscriptions.push(subscription);
        }
      });
    this.subscriptions.push(subscription);
  }
  
  selectDurations($event: any) {
    this.getDowntimeData();
  }

  getDowntimeData() {
    this.selectedType = "Idle/Off";
    const subscription = this.dataservice
      .get(
        `downtime/entry?date=${this.startDate}&deviceId=${this.selecteMachineId}&custId=${this.custId}&duration=${this.selectDuration}`
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res: any) => {
          if (res) {
            this.downData = res["Overall_status"];
            this.typeData = this.downData.filter(
              (val: any) => val.name === "Idle" || val.name === "Off"
            );
            if (this.typeData.length) {
              this.orderedData = this.sortedTypeData(this.typeData);
            } else {
              this.orderedData = [];
            }
          } else {
            this.orderedData = [];
          }
        },
        (error) => {
          this.downData = [];
          this.orderedData = [];
        }
      );
    this.subscriptions.push(subscription);
  }

  sortedTypeData(val: any) {
    return val
      .filter((item: any) => /* Add filtering logic if needed */ true)
      .sort((a: any, b: any) => b.fromTo.localeCompare(a.fromTo));
  }

  // livepart: any;
  // getlivepart() {
  //   const subscription = this.dataservice
  //     .get(
  //       `api/getliveopart?custId=${
  //         this.userData["user"]["custId"]
  //       }&date=${moment(
  //         `${this.startDate} ${this.selectshift?.[0]["startTime"]}`
  //       ).format("DD-MM-YYYY HH:mm:ss")}&shiftId=${
  //         this.userData["user"]["currentShift"]["shiftId"]
  //       }&deviceId=${this.selecteMachineId}`
  //     )
  //     .subscribe(
  //       (res) => {
  //         if (res) {
  //           this.livepart = res;
  //         }
  //       },
  //       (err) => {
  //         this.errmsg = err;
  //         this.toastr.warning("Server Unreachable. Please try again");
  //       }
  //     );
  //   this.subscriptions.push(subscription);
  // }

  getRecords() {
    const subscription = this.dataservice
      .get(
        `api/getsample?custId=${this.userData["user"]["custId"]}&date=${moment(
          `${this.startDate} ${this.selectshift?.[0]["startTime"]}`
        ).format("DD-MM-YYYY HH:mm:ss")}&shiftId=${this.userData["user"]["currentShift"]["shiftId"]
        }&deviceId=${this.selecteMachineId}`
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.sampleData = res;
            if (
              this.sampleData?.length &&
              !this.sampleData[this.sampleData?.length - 1].hasOwnProperty(
                "endTime"
              )
            ) {
              this.showfields = false;
              this.timerRunning = true;
              this.addRecord = false;
              this.deactivate = false;
              this.lastPacketEndtime = true;
              this.currentPart =
                this.sampleData[this.sampleData?.length - 1]["program"];
              // this.startTime=moment.tz(this.sampleData[this.sampleData?.length - 1]["startTime"],this.selectedTimezone).format("HH:mm:ss");//this.epoch(this.sampleData[this.sampleData?.length - 1]["startTime"]);
              this.startTime = moment
                .tz(
                  this.sampleData[this.sampleData?.length - 1]["startTime"],
                  this.selectedTimezone
                )
                .format("HH:mm:ss");
              //this.epoch(this.sampleData[this.sampleData?.length - 1]["startTime"]);

              this.initalizeformTemp();
            } else {
              this.deactivate = true;
              this.showfields = false;
              this.timerRunning = false;
              this.addRecord = true;
              this.currentPart = "";
              this.lastPacketEndtime = false;
            }
            this.filterSampleData();
          }
        },
        (err) => {
          this.errmsg = err;
          this.toastr.warning("Server Unreachable. Please try again");
        }
      );
    this.subscriptions.push(subscription);
  }

  filterSampleData() {
    if (this.searchRecord) {
      this.filteredsampleData = this.sampleData.filter((item) =>
        item.program.toLowerCase().includes(this.searchRecord.toLowerCase())
      );
    } else {
      this.filteredsampleData = this.sampleData;
    }
  }

  gettimestamp(data: any) {
    let starttime, endtime;
    if (
      data[0]["startNextDayFlag"] === false &&
      data[0]["endNextDayFlag"] === true
    ) {
      starttime = moment(
        `${this.startDate} ${data[0]["startTime"]}`,
        "YYYY-MM-DD HH:mm:ss:SSS"
      ).valueOf();
      endtime = moment(
        `${this.startDate} ${data[0]["endTime"]}`,
        "YYYY-MM-DD HH:mm:ss:SSS"
      )
        .add(1, "days")
        .valueOf();
    } else if (
      data[0]["startNextDayFlag"] === true &&
      data[0]["endNextDayFlag"] === false
    ) {
      starttime = moment(
        `${this.startDate} ${data[0]["startTime"]}`,
        "YYYY-MM-DD HH:mm:ss:SSS"
      )
        .add(1, "days")
        .valueOf();
      endtime = moment(
        `${this.startDate} ${data[0]["endTime"]}`,
        "YYYY-MM-DD HH:mm:ss:SSS"
      )
        .add(1, "days")
        .valueOf();
    } else if (
      data[0]["startNextDayFlag"] === false &&
      data[0]["endNextDayFlag"] === false
    ) {
      starttime = moment(
        `${this.startDate} ${data[0]["startTime"]}`,
        "YYYY-MM-DD HH:mm:ss:SSS"
      ).valueOf();
      endtime = moment(
        `${this.startDate} ${data[0]["endTime"]}`,
        "YYYY-MM-DD HH:mm:ss:SSS"
      ).valueOf();
    }
    return { starttime, endtime };
  }

  getMainData() {
    if (this.configType != "no_part") {
      console.log("called");
      this.getPartData();
    }
    this.currentShift = this.shift_Time;
    this.selectedCars = this.currentShift["shiftName"];
    this.params.shiftName = this.shift_Time["usershiftId"];
    this.deviceName = this.params.deviceName;
    this.deviceType = this.params.deviceType;
    delete this.params.deviceName;
    this.getCustData(this.params);
    // this.ganttchart(this.params);
    if (this.configType != "no_part") {
      this.getPartCount(this.params);
    }
    this.dayarray();
      const isCurrentShift =
      this.currentShiftData["usershiftId"] === this.selectedShifts &&
      moment(this.currentShiftData["currentDate"]).format("YYYY-MM-DD") ===
        this.startDate;
    
    if (isCurrentShift) {
      this.getInterlockData(this.params);
    }
  }

  getCustData(param: any) {
    this.m_effic = 0;
    this.perf = 0;
    this.pierunning_response = 0;
    this.pieidle_response = 0;
    this.count = 0;
    param = {
      // shiftName: param.shiftName,
      // deviceType: param.deviceType,
      custID: param.custID,
      deviceID: this.selecteMachineId,
    };
    if (param.shiftName) {
    } else {
      this.params.shiftName = this.currentShift.usershiftId;
    }
    this.dataservice
      .machineApi(
        "machineCard",
        param
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe((res: any) => {
        this.current = res["total_current"];
        this.livepart = res ? res['partName'] : 'NA'
        this.LUT = res["LUT"];
        this.pierunning_response = res["total_running"]
          ? res["total_running"]
          : 0;
        this.pieidle_response = res["total_idle"] ? res["total_idle"] : 0;
        this.m_effic = res["oee"] ? res["oee"].toFixed(1) : 0;
        this.perf = res["performance"] ? res["performance"].toFixed(1) : 0;
        this.quality = res["quality"] ? res["quality"].toFixed(1) : 0;
        this.availability = res["availability"]
          ? res["availability"].toFixed(1)
          : 0;
        this.status = res["status"];
        this.count = res?.part_count || "-";
      });
  }

  getPartCount(param: any) {
    this.parts = 0;
    if (param.shiftName) {
    } else {
      this.params.shiftName = this.currentShift.usershiftId;
    }
    this.dataservice
      .get(`manufacturedPart/counts?date=${this.startDate}&deviceId=${this.selecteMachineId}&custId=${this.custId}`)
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.parts = res["pattern_count"];
            this.type = res["partcount_Type"];
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  dayarray() {
    const today = new Date(); // Get the current date
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const dayBeforeYesterday = new Date(today);
    dayBeforeYesterday.setDate(today.getDate() - 2);
    this.previousDays = [
      yesterday.toISOString().split("T")[0], // Format date to YYYY-MM-DD
      dayBeforeYesterday.toISOString().split("T")[0], // Format date to YYYY-MM-DD
    ];
  }

  selectedShift($event: any) {
    this.selectedCars = $event;
    if (
      this.currentShift.usershiftId === this.selectedCars ||
      this.selectedCars === "All Shift"
    ) {
      this.intervalFlag = true;
    } else {
      this.intervalFlag = false;
    }
    if (this.selectedCars === "All Shift") {
      this.params.shiftName = "all";
    } else {
      this.params.shiftName = this.selectedCars;
    }
    this.showChart = false;
    this.getCustData(this.params);
    this.getPartCount(this.params);
  }

  compareTimes(time1: any, time2: any) {
    const [hours1, minutes1, seconds1] = time1.split(":").map(Number);
    const [hours2, minutes2, seconds2] = time2.split(":").map(Number);
    if (hours1 !== hours2) {
      return hours1 - hours2;
    } else if (minutes1 !== minutes2) {
      return minutes1 - minutes2;
    } else {
      return seconds1 - seconds2;
    }
  }

  getSecondsFromString(timeString: any) {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  }

  epochToHHMMSS(epochTime: any) {
    if (typeof epochTime === "undefined") {
      return "-";
    }
    const isMilliseconds = epochTime > 9999999999;
    const date = new Date(isMilliseconds ? epochTime : epochTime * 1000);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = String(date.getFullYear()).slice(-2);
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // The hour '0' should be '12'
    const formattedHours = String(hours).padStart(2, "0");
    return `${day}/${month}/${year} ${formattedHours}:${minutes}:${seconds} ${ampm}`;
  }

  onMachineChange($event: any) {
    this.cancelPreviousRequests$.next();
    this.selectedType = "Idle/Off";
    this.filteredData = [];
    this.orderedData = [];
    const selectedData = this.machine_List.find(
      (device) => device.deviceName == $event.target.value
    );

    this.selectedMachine = selectedData.deviceName;
    this.selecteMachineId = selectedData.deviceId;
    this.partcountType = selectedData["partcountType"];
    if (selectedData["meterSupplier"] != 'K2-V1.1') {
      this.downtimeType = ["Idle/Off", "Idle", "Off", "Running"];
    } else {
      this.downtimeType = ["Idle/Off", "Idle", "Off", "Running", "Breakdown", "Interlock"];
    }
    this.getshiftDetails(selectedData.departmentName);
    this.configType = selectedData["oee"];
    if (this.configType != "no_part" && this.isMiltiselection) {
      this.getRecords();
    }
    // else if (this.configType != "no_part" && !this.isMiltiselection) {
    //   this.getlivepart();
    // }
    this.getDowntimeData();

    this.result = this.gettimestamp(this.selectshift);
    let shared_data = {
      custID: this.custId,
      deviceID: selectedData["deviceId"],
      deviceName: selectedData["deviceName"],
      deviceType: selectedData["deviceType"],
      startTime: this.result["starttime"],
      endTime: this.result["endtime"],
    };
    if (Object.values(shared_data).length != 0) {
      this.params = shared_data;
      this.getMainData();
    }
    this.getReasonData();
    this.initalizeform();
  }
  
  convertDuration(data: any) {
    const duration = moment.duration(data, "minutes");
    return moment({
      hour: duration.hours(),
      minute: duration.minutes(),
      second: duration.seconds(),
    }).format("HH:mm:ss");
  }

  houers(data: any) {
    let valueInHMS = "00:00:00";
    if (this.pie_response) {
      let existing = this.pie_response.find((item) => item.name == data);
      if (existing == undefined) {
        valueInHMS = "00:00:00";
      } else {
        valueInHMS = this.secondsToHms(existing.value);
      }
    }
    return valueInHMS;
  }

  secondsToHms(d: any) {
    d = Number(d);
    if (Math.sign(d) == -1) {
      d = Math.abs(d);
    }
    const hours = Math.floor(d / 60);
    const minutes = Math.floor(d % 60);
    const seconds = Math.round((d * 60) % 60);
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}`;
  }

  statusColor(data: any) {
    switch (data) {
      case 1: {
        this.currentStatus = "Running";
        return "#548237";
        break;
      }
      case 0: {
        this.currentStatus = "Idle";
        return "#f7c030";
        break;
      }
      case 2: {
        this.currentStatus = "Breakdown";
        return "#eb5857";
        break;
      }
      case 3: {
        this.currentStatus = "Interlock";
        return "#7B542F";
        break;
      }
      case 4: {
        this.currentStatus = "Off";
        return "#b0b0b0";
        break;
      }
    }
  }

  pieChart(data: any) {
    return {
      tooltip: {
        trigger: "item",
        formatter: function (params) {
          var value = params.value;
          var hours = Math.floor(value / 60);
          var minutes = Math.floor(value % 60);
          var seconds = Math.floor((value * 60) % 60);
          var formattedValue =
            hours.toString().padStart(2, "0") +
            ":" +
            minutes.toString().padStart(2, "0") +
            ":" +
            seconds.toString().padStart(2, "0");

          return `${params.seriesName}<br/>${params.name}: ${formattedValue} (${params.percent}%)`;
        },
      },
      legend: {
        top: "5%",
        left: "center",
      },
      series: [
        {
          name: "Status",
          type: "pie",
          radius: ["50%", "70%"],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: "center",
            },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: "30",
                fontWeight: "bold",
              },
            },
            formatter: function (params) {
              return "some text" + echarts.format.formatTime(params.value);
            },
          },
          labelLine: {
            normal: {
              show: false,
            },
          },
          data: data,
        },
      ],
    };
  }

  historyChart() {
    if (this.selectedDateOption == "Live") {
      this.historycombinedData = [];
      this.historydata = false;
      this.intervalFlag = true;
      // this.ganttchart(this.params);
      this.toastr.success("Live On, Please wait we are fetching record");
    } else {
      this.historycombinedData = [];
      var param = {
        custID: this.params["custID"],
        deviceID: this.params["deviceID"],
        date: this.selectedDateOption,
      };
      this.history_chart(param);
      this.toastr.warning("Live Off, Please wait we are fetching record");
      this.intervalFlag = false;
    }
  }

  combined() {
    this.showCombined = !this.showCombined;
  }

  history_chart(param: any) {
    this.showChart = false;
    this.historydata = false;
    this.historyDatas = [];
    this.dataservice.history_chart(param)
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res["overall_status"]?.length > 0) {
            this.showChart = true;
            this.historydata = true;
            this.historyDatas = res["overall_status"];
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  openModal(infotemplate: any) {
    this.modalService.open(infotemplate, {
      backdrop: "static",
      centered: true,
      size: "xl",
    });
  }

  opendowntimeReason(contentTemp: any, data: any) {
    this.downtimeData = data;
    console.log("multi", this.downtimeData, this.startDate)
    this.endtimeData[0] = this.generateTimeArray(
      this.downtimeData.fromTo.split("-")[0].split(".")[0].slice(0, 5),
      this.downtimeData.fromTo.split("-")[1].split(".")[0].slice(0, 6)
    );
    const starttime = this.downtimeData.fromTo.split("-")[0].split(".")[0];
    const endtime = this.downtimeData.fromTo.split("-")[1].split(".")[0];
    this.packetEndtime = this.downtimeData.fromTo.split("-")[1].split(".")[0];
    const formattedStartTime = moment(starttime, "HH:mm:ss").format("HH:mm");
    const formattedEndTime = moment(endtime, "HH:mm:ss").format("HH:mm");
    let datas = {
      startTime: formattedStartTime,
      endTime: formattedEndTime,
      reasonCode: this.downtimeData["reasonData"]["reasonCode"],
      subReasoncode: this.downtimeData["reasonData"]["subReasoncode"],
      reason: this.downtimeData["reasonData"]["reason"],
      subReason: this.downtimeData["reasonData"]["subReason"],
    };
    this.downtimevalues.push(datas);
    console.log(this.downtimevalues, "durationFormatted", this.downtimeData['value'][1], this.downtimeData['value'][2])
    this.changeReason(datas["reason"], 0, datas);
    if (this.endtimeData[0].length == 1 || this.endtimeData[0].length == 2) {
      this.isSame = true;
      this.modalService.open(contentTemp, {
        backdrop: "static",
        centered: true,
      });
    } else {
      this.isSame = false;
      this.modalService.open(contentTemp, {
        backdrop: "static",
        centered: true,
        size: "xl",
      });
    }
  }

  getReasonData() {
    const subscription = this.dataservice.get("api/reasons")
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.reasonData = res;

            this.rejectionReasons = this.filterByReasonType(
              this.reasonData,
              "rejection"
            );
            this.downtimeReasons = this.filterByReasonType(
              this.reasonData,
              "downtime"
            );
            this.downtimeReasons2 = this.reasonData.filter(val => val.reasonType === 'downtime' && val.reasonCode !== 'R0');

          }
        },
        (error) => {
          this.errmsg = "Server Unreachable";
          this.reasonData = [];
          this.downtimeReasons2=[]
          this.toastr.error("Server Unreachable", error.error);
        }
      );
    this.subscriptions.push(subscription);
  }

  filterByReasonType(data: any, type: any) {
    return data.filter((item: any) => item.reasonType === type);
  }

  AddSubReason() {
    let data = {};
    if (this.downtimevalues.length == 0) {
      console.log(this.downtimeData.fromTo.split("-")[0].split(".")[0].slice(0, 5), this.downtimeData.fromTo.split("-")[1].split(".")[0].slice(0, 6), "time")
      this.endtimeData[0] = this.generateTimeArray(
        this.downtimeData.fromTo.split("-")[0].split(".")[0].slice(0, 5),
        this.downtimeData.fromTo.split("-")[1].split(".")[0].slice(0, 6)
      );
      let time = this.downtimeData.fromTo.split("-")[0].split(".")[0];
      let timeInMinutes = time.split(":").slice(0, 2).join(":");
      data = {
        startTime: timeInMinutes,
        endTime: "",
        reason: "",
        subReason: "",
      };
    } else {
      const lastRow = this.downtimevalues[this.downtimevalues.length - 1];
      if (!lastRow.endTime || !lastRow.reason) {
        this.toastr.warning(
          "Please select End Time and Reason before adding a new entry."
        );
        return;
      }
      let previousEndTime = lastRow.endTime; //moment(lastRow.endTime,'hh:mm').add(1,'millisecond').format('hh:mm:ss:sss');
      data = {
        startTime: previousEndTime,
        endTime: "",
        reason: "",
        subReason: "",
        reasonCode: "",
        subReasoncode: "",
      };
    }
    if (Object.values(data).length != 0) {
      this.downtimevalues.push(data);
    }
  }

  changeFormat(data: any) {
    return data ? moment(data).format("HH:mm") : moment.tz().format("HH:mm");
  }

  changeTime(e: any, index: any) {
    const lastRow = this.downtimevalues[this.downtimevalues.length - 1];
    if (lastRow.startTime != e.target.value) {
      const allTimes = this.endtimeData[0];

      // Find the position of the selected endTime
      const startIndex = allTimes.findIndex(
        (time: string) => time === e.target.value
      );

      // Slice from selected endTime till the end (no wrap around)
      this.endtimeData[index + 1] =
        startIndex !== -1 ? allTimes.slice(startIndex) : [];

      this.downtimevalues[index].endTime = e.target.value;

      let lastData;
      if (this.endtimeData[index + 1].length == 1) {
        lastData = this.endtimeData[index + 1];
      }
      if (lastData == e.target.value) {
        this.addBool = false;
      } else {
        this.addBool = true;
      }
      this.timeBool = false;
    } else if (lastRow.endTime == e.target.value) {
      this.timeBool = true;
      this.toastr.warning("Selected time is same. Please change time");
    }
  }


  // changeTime(e: any, index: any) {
  //   const lastRow = this.downtimevalues[this.downtimevalues.length - 1];
  //   console.log( e.target.value,index,lastRow,'index')
  //   if (lastRow.startTime != e.target.value) {
  //     this.endtimeData[index + 1] = this.endtimeData[0].filter(
  //       (time: string) => time >= lastRow.endTime
  //     );
  //     this.downtimevalues[index].endTime = e.target.value;
  //     let lastData;
  //     if (this.endtimeData[index + 1].length == 1) {
  //       lastData = this.endtimeData[index + 1];
  //     }
  //     if (lastData == e.target.value) {
  //       this.addBool = false;
  //     } else {
  //       this.addBool = true;
  //     }
  //     this.timeBool = false;
  //     console.log(this.endtimeData,"this.endtimeData")
  //   } else if (lastRow.endTime == e.target.value) {
  //     this.timeBool = true;
  //     this.toastr.warning("Selected time is same.Please change time");
  //   }
  // }

  changeReason(e: any, index: any, type: any) {
    if (type == "ui") {
      this.downtimevalues[index].reason = e;
      let data = this.downtimeReasons.find((val) => val.reason === e);
      this.subReasonData[index] = data?.["subReason"];
      if (this.subReasonData[index]?.length) {
        this.downtimevalues[index]["subReason"] =
          this.subReasonData[index][0]["subReason"];
      }
      this.downtimevalues[index].reasonCode = data?.["reasonCode"];
      this.downtimevalues[index].subReason = "";
    } else {
      this.downtimevalues[index].reason = e;
      let data = this.downtimeReasons.find((val) => val.reason === e);
      this.subReasonData[index] = data?.["subReason"];
      if (this.subReasonData[index]?.length) {
        this.downtimevalues[index]["subReason"] = type["subReason"];
      }
      this.downtimevalues[index].reasonCode = data?.["reasonCode"];
    }
  }

  changesubReason(e: any, index: any) {
    this.downtimevalues[index].subReason = e.target.value;
    let data = this.subReasonData[index].find(
      (val: any) => val.subReason === e.target.value
    );
    this.downtimevalues[index].subReasoncode = data["subReasonCode"];
  }

  removeRow(index: number): void {
    if (index > -1 && index < this.downtimevalues.length) {
      this.downtimevalues.splice(index, 1);
      this.addBool = true;
      this.timeBool = false;
    }
  }

  generateTimeArray(startTime: any, endTime: any) {
    const [startHour, startMinute] = startTime.split(":").map(Number);
    const [endHour, endMinute] = endTime.split(":").map(Number);
    if (startHour === endHour && startMinute === endMinute) {
      return [
        `${String(startHour).padStart(2, "0")}:${String(startMinute).padStart(
          2,
          "0"
        )}`,
      ];
    }
    const result = [];
    let currentHour = startHour;
    let currentMinute = startMinute;
    while (true) {
      result.push(
        `${String(currentHour).padStart(2, "0")}:${String(
          currentMinute
        ).padStart(2, "0")}`
      );
      currentMinute++;
      if (currentMinute === 60) {
        currentMinute = 0;
        currentHour++;
      }
      if (currentHour === 24) {
        currentHour = 0;
      }
      if (currentHour === endHour && currentMinute === endMinute) {
        result.push(
          `${String(currentHour).padStart(2, "0")}:${String(
            currentMinute
          ).padStart(2, "0")}`
        );
        break;
      }
    }
    return result;
  }

  selectChoice($event: any) {
    if ($event.target.value == "single") {
      this.singlebool = true;
      this.searchCount = 0;
      this.getCount();
    } else if ($event.target.value == "multiple") {
      this.singlebool = false;
    }
  }

  selectHour(event: any) {
    console.log(event, "$event")
    this.selectedHour = event;
    this.getRejectionData();
  }

  getCount() {
    if (
      this.searchCount &&
      this.searchCount <= this.validcount &&
      this.searchCount >= 0
    ) {
      let selected = 0;
      this.rejectionData = this.rejectionData.map((val) => {
        if (!val.isRejected) {
          if (this.searchCount > selected) {
            val["flag"] = true;
            selected++;
          } else {
            val["flag"] = false;
          }
        } else {
          val["flag"] = false;
        }
        return val;
      });
      this.showModel = true;
      this.validNumber = this.searchCount;
    } else {
      this.showModel = false;
      this.rejectionData = this.rejectionData.map((val) => {
        val["flag"] = false;
        return val;
      });
    }
  }

  multiReasonclose() {
    this.modalService.dismissAll();
    this.searchCount = 0;
    this.getCount();
  }

  generateUUID() {
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  multidownReason() {
    if (!this.isSame) {
      const lastRow = this.downtimevalues[this.downtimevalues.length - 1];
      if (!lastRow.endTime || !lastRow.reason) {
        this.toastr.warning("Please select Reason before Save.");
        return;
      }

      // Base start & end from original downtime (ms timestamps)
      const baseStartTime2 = moment(this.downtimeData.value[1]);
      const baseEndTime2 = moment(this.downtimeData.value[2]);

      const finalRes = this.downtimevalues.map((reason, index) => {
        let fromToStart: moment.Moment;
        let fromToEnd: moment.Moment;

        if (index === 0) {
          // first packet must always start with base start
          fromToStart = baseStartTime2.clone();
        } else {
          fromToStart = moment(
            `${baseStartTime2.format("YYYY-MM-DD")} ${reason.startTime}`,
            "YYYY-MM-DD HH:mm"
          );
          // if this start is before previous packet → it’s next day
          if (fromToStart.isBefore(baseStartTime2)) {
            fromToStart.add(1, "day");
          }
        }

        if (index === this.downtimevalues.length - 1) {
          // last packet must always end with base end
          fromToEnd = baseEndTime2.clone();
        } else {
          fromToEnd = moment(
            `${baseStartTime2.format("YYYY-MM-DD")} ${reason.endTime}`,
            "YYYY-MM-DD HH:mm"
          );
          // if end < start → next day
          if (fromToEnd.isBefore(fromToStart)) {
            fromToEnd.add(1, "day");
          }
        }

        // duration
        const duration = moment.duration(fromToEnd.diff(fromToStart));
        const durationFormatted = `${String(duration.hours()).padStart(2, "0")}:${String(
          duration.minutes()
        ).padStart(2, "0")}:${String(duration.seconds()).padStart(2, "0")}.${String(
          duration.milliseconds()
        ).padStart(3, "0")}`;

        return {
          fromTo: `${fromToStart.format("HH:mm:ss.SSS")} - ${fromToEnd.format(
            "HH:mm:ss.SSS"
          )}`,
          id: this.downtimeData.id,
          _id: this.generateUUID(),
          name: this.downtimeData.name,
          value: [
            0,
            fromToStart.valueOf(),
            fromToEnd.valueOf(),
            durationFormatted,
          ],
          itemStyle: this.downtimeData.itemStyle,
          reasonData: {
            reasonCode: reason.reasonCode,
            subReasoncode: reason.subReasoncode,
            reason: reason.reason,
            subReason: reason.subReason,
          },
        };
      });


      this.addDowntimeReason(
        finalRes,
        this.downtimeData.id,
        this.downtimeData._id,
        "multi"
      );
    }
    else {
      const lastRow = this.downtimevalues[this.downtimevalues.length - 1];
      if (!lastRow.reason) {
        this.toastr.warning("Please select Reason before Save.");
        return;
      }
      let reasonObj = {};
      reasonObj["reasonCode"] = lastRow["reasonCode"];
      reasonObj["subReasoncode"] = lastRow["subReasoncode"];
      reasonObj["reason"] = lastRow["reason"];
      reasonObj["subReason"] = lastRow["subReason"];
      let data = {};
      (data["fromTo"] = this.downtimeData.fromTo),
        (data["itemStyle"] = this.downtimeData.itemStyle),
        (data["name"] = this.downtimeData.name),
        (data["value"] = this.downtimeData.value),
        (data["reasonData"] = reasonObj);
      this.addDowntimeReason(
        data,
        this.downtimeData.id,
        this.downtimeData._id,
        "single"
      );
    }
  }

  addDowntimeReason(data: any, id: any, _id: any, type: any) {
    if (type == "multi") {
      if (this.addBool) {
        return this.toastr.info("Select Upto Packet End Time!");
      }
      this.finalData.push(...data);
    } else {
      this.finalData.push(data);
    }
    this.dataservice
      .post(`downtime/entry?id=${id}&_id=${_id}`, this.finalData)
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.toastr.success("Dowtime Reason Added Successfully");
            this.getDowntimeData();
            this.multidownclose();
            this.finalData = [];
          }
        },
        (error) => {
          this.finalData = []
        }
      );
  }

  multidownclose() {
    this.downtimevalues = [];
    this.endtimeData = [];
    this.addBool = false;
    this.timeBool = false;
    this.modalService.dismissAll();
  }

  toggleFlag(item: any) {
    item.flag = !item.flag;
    this.filteredData = [...this.filteredData];
  }

  onReason(item: any) {
    let data = {};
    data["_id"] = item._id;
    data["Reason"] = item.Reason;
    data["usershiftId"] = item.usershiftId;
    data["custId"] = item.custId;
    data["date"] = item.date;
    data["partId"] = item.partId;
    data["partName"] = item.partName;
    data["time"] = item.time;
    data["deviceId"] = item.deviceId;
    if (item.id != undefined) {
      data["id"] = item.id;
    }
    if (item.Reason) {
      data["isRejected"] = true;
    } else {
      data["isRejected"] = false;
    }
    this.dataservice.post(`rejection/entry`, data)
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.getRejectionData();
            this.toastr.success("Rejection Done");
          }
        },
        (error) => {
          console.log(error);
          this.toastr.error(error.error);
        }
      );
  }

  onReason2($event: any) {
    this.selectedRejection = $event.target.value;
  }

  multiReason() {
    let data = this.rejectionData
      .filter((val) => val.flag === true)
      .map((val) => {
        let datas = {};
        datas["_id"] = val._id;
        datas["Reason"] = this.selectedRejection;
        datas["usershiftId"] = val.usershiftId;
        datas["custId"] = val.custId;
        datas["date"] = val.date;
        datas["partId"] = val.partId;
        datas["partName"] = val.partName;
        datas["time"] = val.time;
        datas["deviceId"] = val.deviceId;
        datas["isRejected"] = !!this.selectedRejection;
        if (val.id != undefined) {
          datas["id"] = val.id;
        }
        return datas;
      });
    this.dataservice.post(`rejection/entry/`, data)
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res) => {
          if (res) {
            this.getRejectionData();
            this.multiReasonclose();
            this.toastr.success("Rejection Done");
          }
        },
        (error) => {
          this.toastr.error(error.error);
        }
      );
  }

  getPartData() {
    let urlData:any;
    if(this.role=='OPERATOR'){
      urlData= `mapping/operatorMapping?date=${this.startDate}&usershiftId=${this.selectedShifts}&deviceId=${this.selecteMachineId
        }&deviceName=${this.selectedMachine}&custId=${this.custId}&operatorId=${this.userData["user"]["name"]}`
    }else{
      urlData= `mapping/operatorMapping?date=${this.startDate}&usershiftId=${this.selectedShifts}&deviceId=${this.selecteMachineId
        }&deviceName=${this.selectedMachine}&custId=${this.custId}`
    }
    const subscription = this.dataservice
      .get(
        urlData
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res: any) => {
          if (res.length) {
            this.showPartData = true;
            if (this.isMiltiselection) {
              this.partData = res?.[0]?.["target"] || [];
            } else {
              this.partData = res || [];
              // this.livepart = res.length ? res[res.length - 1] : 'NA'
            }
            this.selectedPart = this.partData[this.partData.length - 1]["partName"];
            // this.selectedPartproduced = this.partData[this.partData.length - 1]["partProduced"];
            this.getComment()
            this.getRejectionData();
          } else {
            this.showPartData = false;
            this.getRejectionData();
            this.partData = [];
          }
        },
        (error) => {
          console.log(error);
          this.partData = [];
        }
      );
    this.subscriptions.push(subscription);
  }

  getRejectionData() {
    this.result = this.gettimestamp(this.selectshift);
    const subscription = this.dataservice
      .get(
        `rejection/entry?date=${this.startDate}&shiftId=${this.shiftId
        }&selectedHour=${this.selectedHour || 'All'
        }&startTime=${this.result["starttime"]}&endTime=${this.result["endtime"]
        }&usershiftId=${this.selectedShifts}&deviceId=${this.selecteMachineId
        }&custId=${this.custId}${this.showPartData ? `&partName=${this.selectedPart}` : ""
        }`
      )
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res: any) => {
          if (res) {
            this.rejectionData = res;
            this.filterData();
            this.selectedPartproduced = this.rejectionData
              ? this.rejectionData.length
              : 0;
            this.selectedPartrejected = this.rejectionData.filter(
              (item) => item.isRejected
            ).length;
            this.validcount =
              this.selectedPartproduced - this.selectedPartrejected;
          } else {
            this.rejectionData = [];
            this.filteredData = [];
          }
        },
        (error) => {
          this.rejectionData = [];
          this.filteredData = [];
        }
      );
    this.subscriptions.push(subscription);
  }

  // filterData() {
  //   if (this.searchTerm2) {
  //     this.filteredData = this.rejectionData.filter((item) =>
  //       item.partId.toString().toLowerCase().includes(this.searchTerm2.toLowerCase())
  //     );
  //   } else {
  //     this.filteredData = this.rejectionData;
  //   }
  // }

  filterData() {
  let data = this.rejectionData;

  if (this.searchTerm2) {
    data = data.filter((item) =>
      item.partId.toString().toLowerCase().includes(this.searchTerm2.toLowerCase())
    );
  }

  if (this.selectedStatus === 'pass') {
    data = data.filter((item) => !item.isRejected);
  } else if (this.selectedStatus === 'reject') {
    data = data.filter((item) => item.isRejected);
  }
  console.log(data)
  this.filteredData = data;
}

  LiveChart(params: any) {
    // this.ganttchart(params);
    this.getPartCount(params);
  }

  onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }

  onPageChange1(pageNum: number): void {
    this.pageSize1 = this.itemsPerPage1 * (pageNum - 1);
  }

  onPageChange2(pageNum: number): void {
    this.pageSize2 = this.itemsPerPage2 * (pageNum - 1);
  }
  onPagecontentChange(pageNum: number): void {
    this.constentSize = this.commentsPerPage * (pageNum - 1);
  }


  select_Date(e: any) {
    this.cancelPreviousRequests$.next();
    this.filteredData = [];
    if (moment.tz(this.selectedTimezone).format("YYYY-MM-DD") == e) {
      this.isToday = true;
    } else {
      this.isToday = false;
    }
    this.startDate = e;
    this.getData();
  }

  select_Shift(e: any) {
    this.cancelPreviousRequests$.next();
    this.filteredData = [];
    this.selectedShifts = e;
    let data = this.shiftsArr.filter((val) => {
      if (val.usershiftId == e) {
        return val;
      }
    });
    this.selectshift = data;
    this.shiftId = data[0]["shiftId"];
    this.shiftName = data[0]["shiftName"];
    this.hours = this.generateHourArray(this.selectshift[0])

    this.getDowntimeData();
    if (this.configType != "no_part" && this.isMiltiselection) {
      this.getRecords();
    }
    // else if (this.configType != "no_part" && !this.isMiltiselection) {
    //   this.getlivepart();
    // }
    this.result = this.gettimestamp(this.selectshift);
    var shared_data = {
      custID: this.custId,
      deviceID: this.machine_List[0]["deviceId"],
      deviceName: this.machine_List[0]["deviceName"],
      deviceType: this.machine_List[0]["deviceType"],
      startTime: this.result["starttime"],
      endTime: this.result["endtime"],
    };
    if (Object.values(shared_data).length != 0) {
      this.params = shared_data;
      this.getMainData();
    }
    // this.getPartData();
    // this.getRejectionData();
    // this.getDowntimeData();
    // this.getData();
  }

  select_Part(e: any) {
    this.cancelPreviousRequests$.next();
    this.filteredData = [];
    this.selectedPart = e;
    this.getRejectionData();
    this.getComment()
  }

  updateTime() {
    this.currentTime = new Date();
    let currentTime = moment.tz(this.selectedTimezone).valueOf(),
      shiftEndTime = moment
        .tz(
          this.shift_Time.endDateTime,
          "YYYY-MM-DDTHH:mm:ss",
          this.selectedTimezone
        )
        .valueOf();
    if (currentTime >= shiftEndTime) {
      this.getRecords();
      if (this.sampleData?.length) {
        if (
          this.sampleData[this.sampleData?.length - 1].hasOwnProperty(
            "endTime"
          ) &&
          moment(this.shift_Time["start"]).format("DD-MM-YYYY HH:mm:ss") ==
          this.sampleData[this.sampleData?.length - 1]["date"]
        ) {
          //Do nothing
        } else if (
          moment(this.shift_Time["start"]).format("DD-MM-YYYY HH:mm:ss") ==
          this.sampleData[this.sampleData?.length - 1]["date"]
        ) {
          let data = {};
          this.submitted = true;
          data["sample"] =
            this.sampleData[this.sampleData.length - 1]["sample"];
          data["program"] = this.validationform.value["program"];
          data["custId"] = this.userData["user"]["custId"];
          data["startTime"] = this.epoch(this.startTime);
          data["endTime"] = shiftEndTime;
          data["duration"] =
            this.getTimeDifference(
              moment
                .tz(data["startTime"], this.selectedTimezone)
                .format("HH:mm:ss"),
              moment
                .tz(data["endTime"], this.selectedTimezone)
                .format("HH:mm:ss")
            ) || "00:00:00";
          data["deviceId"] = this.selecteMachineId;
          data["deviceName"] = this.selectedMachine;
          data["operatorEmail"] = this.userData["user"]["email"];
          data["shiftId"] = this.shift_Time["shiftId"];
          data["date"] = moment(this.shift_Time["start"]).format(
            "DD-MM-YYYY HH:mm:ss"
          );

          if (data["endTime"] == shiftEndTime) {
            this.dataservice.post("api/addsample", data).subscribe(
              (res) => {
                if (res) {
                  this.toastr.success("Sample record Added Successfully");
                  this.endTime = "";
                  this.startTime = "";
                  this.duration = "";
                  this.sampleName = "";
                  this.submitted = false;
                  this.deactivate = true;
                  sessionStorage.setItem("Deactivate", "true");
                  this.showfields = false;
                  this.timerRunning = false;
                  this.getRecords();
                  let sessionShift = this.getCurrent.getCurrentShift(
                    this.shiftsArr,
                    this.selectedTimezone
                  );
                  this.userData = this.userData;
                  this.userData["user"]["currentShift"] = sessionShift;
                  sessionStorage.setItem(
                    "currentUser",
                    JSON.stringify(this.userData)
                  );
                }
              },
              (error) => {
                console.log(error, "error");
              }
            );
          }
        }
      }
    }
  }

  startTimer() {
    if (this.showPartData) {
      this.addRecord = false;
      this.deactivate = !this.deactivate;
      sessionStorage.setItem("Deactivate", "false");
      this.timerRunning = true;
      this.startTime = moment.tz(this.selectedTimezone).format("HH:mm:ss");
    }
  }

  caldiff() {
    this.currEnd = moment.tz(this.selectedTimezone).format("HH:mm:ss");
    this.diffData = this.getTimeDifference(this.startTime, this.currEnd);
    return this.diffData;
  }

  getSelectedPart(data: any) {
    this.currentPart = data;
  }

  converdata(dateString: any) {
    const date = new Date(dateString);
    const hours = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);
    const seconds = ("0" + date.getSeconds()).slice(-2);
    return hours + ":" + minutes + ":" + seconds;
  }

  stopTimer() {
    this.addRecord = true;
    clearInterval(this.timer);
    this.timerRunning = false;
    this.currentTime = moment.tz(this.selectedTimezone).format("HH:mm:ss"); //new Date();
    this.endTime = this.currentTime; //this.converdata(this.currentTime);
    this.duration = this.getTimeDifference(this.startTime, this.endTime);
    this.showfields = !this.showfields;
    this.saveDatas();
  }

  getTimeDifference(time1: any, time2: any) {
    const [hours1, minutes1, seconds1] = time1.split(":").map(Number);
    const [hours2, minutes2, seconds2] = time2.split(":").map(Number);
    const milliseconds1 = (hours1 * 3600 + minutes1 * 60 + seconds1) * 1000;
    const milliseconds2 = (hours2 * 3600 + minutes2 * 60 + seconds2) * 1000;
    const diffMilliseconds = Math.abs(milliseconds2 - milliseconds1);
    const hours = Math.floor(diffMilliseconds / (1000 * 60 * 60));
    const minutes = Math.floor(
      (diffMilliseconds % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((diffMilliseconds % (1000 * 60)) / 1000);
    const formattedHours = ("0" + hours).slice(-2);
    const formattedMinutes = ("0" + minutes).slice(-2);
    const formattedSeconds = ("0" + seconds).slice(-2);
    return formattedHours + ":" + formattedMinutes + ":" + formattedSeconds;
  }

  openModalrecoard(contentTemp: any) {
    this.modalService.open(contentTemp, { backdrop: "static", centered: true });
  }

  openModalsample(contentTemp: any) {
    this.actions = 'Edit'
    this.modalService.open(contentTemp, { backdrop: "static", centered: true });
  }

  openModaladdsample(contentTemp: any) {
    this.actions = 'Add'
    this.modalService.open(contentTemp, { backdrop: "static", centered: true });
  }

  openModaladdrecoard(contentTemp: any, data: any) {
    if (this.showPartData) {
      this.action = data;
      this.modalService.open(contentTemp, {
        backdrop: "static",
        centered: true,
      });
    } else {
      this.toastr.warning("Please do the Production Planning");
    }
  }

  openrejectionReason(contentTemp: any) {
    if (this.showModel) {
      this.modalService.open(contentTemp, {
        backdrop: "static",
        centered: true,
      });
    }
  }

  initalizeform() {
    if (this.isMiltiselection) {
      this.validationform = this.formBuilder.group({
        program: ["", [Validators.required]],
      });
    }
  }

  initalizeformTemp() {
    this.validationform = this.formBuilder.group({
      program: [
        this.sampleData[this.sampleData.length - 1]["program"],
        [Validators.required],
      ],
    });
  }

  generateRandomName = (length: any) =>
    Array.from(
      { length },
      () =>
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"[
        Math.floor(Math.random() * 52)
        ]
    ).join("");

  saveDatas() {
    this.validationform.get("program").enable();
    let data = {};
    if (this.action == "Add") {
      this.sampleName = this.generateRandomName(8);
      data["sample"] = this.sampleName;
      data["program"] = this.validationform.value["program"];
      data["custId"] = this.userData["user"]["custId"];
      data["startTime"] = this.epoch(this.startTime);
      data["deviceId"] = this.selecteMachineId;
      data["deviceName"] = this.selectedMachine;
      data["operatorEmail"] = this.userData["user"]["email"];
      data["shiftId"] = this.userData["user"]["currentShift"]["shiftId"];
      data["date"] = moment(this.userData["user"]["currentShift"]["start"])
        .tz(this.selectedTimezone)
        .format("DD-MM-YYYY HH:mm:ss");
      data["_date"] = moment(this.userData["user"]["currentShift"]["start"])
        .tz(this.selectedTimezone)
        .format("DD-MM-YYYY");
    } else {
      this.submitted = true;
      data["sample"] = this.lastPacketEndtime
        ? this.sampleData[this.sampleData.length - 1]["sample"]
        : this.sampleName;
      data["program"] = this.lastPacketEndtime
        ? this.sampleData[this.sampleData.length - 1]["program"]
        : this.validationform.value["program"];
      data["custId"] = this.userData["user"]["custId"];
      data["startTime"] = this.epoch(this.startTime);
      data["endTime"] = this.epoch(this.endTime);
      data["duration"] = this.duration;
      data["deviceId"] = this.selecteMachineId;
      data["deviceName"] = this.selectedMachine;
      data["operatorEmail"] = this.userData["user"]["email"];
      data["shiftId"] = this.userData["user"]["currentShift"]["shiftId"];
      data["date"] = moment(this.userData["user"]["currentShift"]["start"])
        .tz(this.selectedTimezone)
        .format("DD-MM-YYYY HH:mm:ss");
    }
    if (this.validationform.status === "VALID") {
      this.dataservice.post("api/addsample", data).subscribe((res) => {
        if (res) {
          this.toastr.success("Sample record Added Successfully");
          if (this.action != "Add") {
            this.endTime = "";
            this.startTime = "";
            this.duration = "";
            this.sampleName = "";
            this.submitted = false;
            this.deactivate = true;
            sessionStorage.setItem("Deactivate", "true");
            this.showfields = false;
            this.close();
            this.getRecords();
          } else if (this.action == "Add") {
            this.closeAdd();
          }
        }
      });
    } else {
      return this.validationform.controls;
    }
  }

  get form() {
    return this.validationform.controls;
  }

  // epoch(time: any) {
  //   let currentDate =  new Date();
  //   let [hours, minutes, seconds] = time.split(":").map(Number);
  //   currentDate.setHours(hours);
  //   currentDate.setMinutes(minutes);
  //   currentDate.setSeconds(seconds);
  //   let epochTime = currentDate.getTime();
  //   return epochTime;
  // }

  epoch(time: string) {
    let currentDate = moment().tz(this.selectedTimezone);
    let [hours, minutes, seconds] = time.split(":").map(Number);

    currentDate.set({
      hour: hours,
      minute: minutes,
      second: seconds,
      millisecond: 0,
    });

    return currentDate.valueOf(); // Returns timestamp in milliseconds
  }

  formatTime(data: any) {
    return data
      ? moment.tz(data, this.selectedTimezone).format("HH:mm:ss")
      : moment.tz(this.selectedTimezone).format("HH:mm:ss");
  }

  close() {
    this.modalService.dismissAll();
    this.deactivate = true;
    sessionStorage.setItem("Deactivate", "true");
    this.hideMachine = false;
    this.submitted = false;
    this.startTime = "";
    this.endTime = "";
    this.duration = "";
    this.validationform.get("program").enable();
    this.showfields = false;
  }

  close1() {
    this.modalService.dismissAll();
    this.timerRunning = false;
    this.deactivate = true;
    this.startTime = "";
    this.endTime = "";
    this.duration = "";
    this.addRecord = true;
    sessionStorage.setItem("Deactivate", "true");
  }

  closeAdd() {
    this.modalService.dismissAll();
    this.action = false;
    this.getRecords();
  }

  showNavigationNotAllowedToast() {
    this.toastr.error(
      "You are not allowed to navigate away.",
      "Permission Denied"
    );
  }

  selectType($event: any) {
    this.selectedType = $event.target.value;
    if (this.selectedType == "Idle/Off") {
      this.typeData = this.downData.filter(
        (val: any) => val["name"] == "Idle" || val["name"] == "Off"
      );
    } else {
      this.typeData = this.downData.filter(
        (val: any) => val["name"] == this.selectedType
      );
    }
    if (this.typeData.length) {
      this.orderedData = this.sortedTypeData(this.typeData);
    } else {
      this.orderedData = [];
    }
  }

  checkCount(val: any) {
    return val ? val : 0;
  }

  canDeactivate(): boolean {
    if (!this.deactivate) {
      this.showNavigationNotAllowedToast();
    } else {
      return this.deactivate;
    }
  }

  getComment() {

    let obj = {
      custId: this.custId,
      commentText: this.commentText,
      machineId: this.selecteMachineId,
      date: this.startDate,
      usershiftId: this.selectedShifts,
      partName: this.selectedPart,
      operatorName: this.operatorName.trim() // remove extra spaces
    };

    console.log(obj);

    // FIXED URL → removed extra "}"
    const url = `api/comment?date=${obj.date}`
      + `&usershiftId=${obj.usershiftId}`
      + `&machineId=${obj.machineId}`
      + `&custId=${obj.custId}`
      + `&partName=${encodeURIComponent(obj.partName)}`

    const subscription = this.dataservice.get(url).pipe(takeUntil(this.cancelPreviousRequests$)).subscribe(
      (res: any) => {
        if (res) {
          this.comments = res
        } else {
          this.comments = []
          console.log("No response");
        }
      },
      (error) => {
        this.comments = []
        console.error("Error saving comment:", error);
      }
    );

    this.subscriptions.push(subscription);
  }

  commentclose() {
    this.commentText = ''
  }

  editComment(data: any) {
    this.actions = 'edit'
    this.commentText = data['commentText'];
    this.commentId = data['id']
  }

  saveComment() {
    if (this.actions == 'Add') {
      const payload = {
        custId: this.custId,
        commentText: this.commentText,
        machineId: this.selecteMachineId,
        date: this.startDate,
        usershiftId: this.selectedShifts,
        partName: this.selectedPart,
        operatorName: this.operatorName.trim()
      };

      const subscription = this.dataservice
        .post("api/comment", payload)
        .pipe(takeUntil(this.cancelPreviousRequests$))
        .subscribe(
          (res: any) => {
            this.getComment()
            this.modalService.dismissAll()
            this.commentclose()
          },
          (error) => {
            console.error("Error saving comment:", error);
          }
        );

      this.subscriptions.push(subscription);

    } else {
      const payload = {
        custId: this.custId,
        commentText: this.commentText,
        machineId: this.selecteMachineId,
        date: this.startDate,
        usershiftId: this.selectedShifts,
        partName: this.selectedPart,
        operatorName: this.operatorName.trim()
      };

      const subscription = this.dataservice
        .put(`api/comment?id=${this.commentId}`, payload)
        .pipe(takeUntil(this.cancelPreviousRequests$))
        .subscribe(
          (res: any) => {
            this.getComment()
            this.modalService.dismissAll()
            this.commentclose()
          },
          (error) => {
            console.error("Error updating comment:", error);
          }
        );

      this.subscriptions.push(subscription);
    }
  }


  // Delete comment
  deleteComment(id: any) {
    const subscription = this.dataservice
      .delete(`api/comment?id=${id}`)
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res: any) => {
          this.getComment()
        },
        (error) => {
          console.error("Error deleting comment:", error);
        }
      );

    this.subscriptions.push(subscription);
  }

    // ═══════════════════════════════════════════════════════════════════════════
  // INTERLOCK
  // ═══════════════════════════════════════════════════════════════════════════

  getInterlockData(params: any) {
    this.result = this.result || this.gettimestamp(this.selectshift);
    const obj = {
      custID: params["custID"],
      deviceID: params["deviceID"],
      startTime: this.result["starttime"],
      endTime: this.result["endtime"],
    };

    return this.dataservice
      .interlockApi("interlocking", obj)
      .toPromise()
      .then(
        (res: any) => {
          this.interlockData = res?.length
            ? res.filter((val: any) => val.cmdType === "cmd" && val.interlockReason === 1)
            : [];
        },
        (error) => this.toastr.error("Server Unreachable", error.message)
      );
  }

  async openInterlockModal() {
    await this.getInterlockData(this.params);
    setTimeout(() => {
      if (this.interlockData.length) {
        this.modalService.open(this.interlock, {
          backdrop: "static",
          centered: true,
          size: "xl",
        });
      }
    });
  }

  submitInterlock(item: any) {
    if (!item.reasonCode) {
      this.toastr.warning("Please select a Reason.");
      return;
    }
    if (item.subreasonData?.length && !item.subReasonCode) {
      this.toastr.warning("Please select a Sub Reason.");
      return;
    }

    let subReasonIndex = 0;
    if (item.subreasonData?.length && item.subReasonCode) {
      const selected = item.subreasonData.find(
        (val: any) => val.subReasonCode === item.subReasonCode
      );
      subReasonIndex = item.subreasonData.indexOf(selected) + 1;
    }

    const payload = {
      deviceId: this.params["deviceID"],
      interlockReason: item.interlockReason,
      reasonCode: Number(item.reasonCode.slice(1)),
      subReasonCode: subReasonIndex,
      name: this.custName?.name || "",
    };

    item.isPending = true;
    const subscription = this.dataservice
      .interlockApi("interlocking/publish", payload)
      .subscribe(
        () => {
          this.toastr.success("Submitted. Waiting for device acknowledgement...");
          this.pollForAck(item);
        },
        (error) => {
          item.isPending = false;
          this.toastr.error(error.message);
        }
      );
    this.subscriptions.push(subscription);
  }

  pollForAck(item: any) {
    if (item.poller) clearInterval(item.poller);
    let retryCount = 0;
    const maxRetries = 3;

    item.poller = setInterval(() => {
      retryCount++;
      this.result = this.result || this.gettimestamp(this.selectshift);
      const pollSub = this.dataservice
        .interlockApi("interlocking", {
          custID: this.params["custID"],
          deviceID: this.params["deviceID"],
          startTime: this.result["starttime"],
          endTime: this.result["endtime"],
        })
        .subscribe(
          (res: any) => {
            if (res?.length) {
              const stillPending = res.find(
                (val: any) =>
                  val.ts === item.ts &&
                  val.interlockReason === item.interlockReason &&
                  val.cmdType === "cmd" && val.interlockReason === 1
              );
              if (!stillPending) {
                clearInterval(item.poller);
                item.poller = null;
                item.isPending = false;
                this.toastr.success(`${item.parameter} acknowledged.`);
                this.refreshInterlockData(res);
              }
            } else if (res?.length === 0) {
              clearInterval(item.poller);
              item.poller = null;
              this.interlockData = [];
              this.modalService.dismissAll();
            }
            if (retryCount >= maxRetries) {
              clearInterval(item.poller);
              item.poller = null;
              item.isPending = false;
              this.toastr.warning(
                `${item.parameter} did not acknowledge. Please try again.`
              );
            }
          },
          (error) => {
            clearInterval(item.poller);
            item.poller = null;
            item.isPending = false;
            this.toastr.error("Ack check failed: " + error.message);
          }
        );
      this.subscriptions.push(pollSub);
    }, 3000);
  }
    getChangeReason(el: any, item: any) {
    const data = this.downtimeReasons2.filter((val: any) => val.reasonCode === el);
    if (data?.length) {
      item.subReasonCode = "";
      item.subreasonData = data[0]["subReason"] || [];
    } else {
      item.subreasonData = [];
    }
  }

  refreshInterlockData(res: any) {
    const updatedList = res.filter((val: any) => val.cmdType === "cmd" && val.interlockReason === 1);
    this.interlockData = updatedList.map((newItem: any) => {
      const existing = this.interlockData.find(
        (old: any) => old.deviceId === newItem.deviceId && old.ts === newItem.ts
      );
      return existing
        ? {
            ...existing,
            ...newItem,
            isPending: existing.isPending,
            poller: existing.poller,
            subreasonData: existing.subreasonData,
          }
        : newItem;
    });
    if (!this.interlockData.length) this.modalService.dismissAll();
  }

  clearAllPollers() {
    this.interlockData.forEach((item: any) => {
      if (item.poller) {
        clearInterval(item.poller);
        item.poller = null;
      }
    });
  }

  ngOnDestroy() {
    if (this.timerRunning) {
      this.stopTimer();
    }
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    if (this.apiInterval) {
      clearInterval(this.apiInterval);
    }
    if (this.timer) clearInterval(this.timer);
    this.destroy$.next();
    this.destroy$.complete();
  }

}
